import TextArea from 'antd/es/input/TextArea';
import MyInput from '../../../components/ui/MyInput';
import { Dropdown } from 'primereact/dropdown';
import { useEffect, useState } from 'react';
import UploadImgPublish from '../../../components/ui/UploadImgPublish';
import Toggle from '../../ThemeScreen/DnDNew/components/DnDItems/DnDSidebarItems/Inputs/Toggle';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Checkbox, RadioGroup, Radio } from '@nextui-org/react';
import FirebaseIntegrationsItem from '../Integrations/FirebaseIntegrationsItem';
import CreateAction from '../../../components/operational/createAction';
import systemSlice from '../../../redux/systemSlice';
import { translate } from '../../../utils/language';
import PhoneInput from 'react-phone-input-2';
import Datepicker from 'react-tailwindcss-datepicker';
import dayjs from 'dayjs';
import { TimePicker } from 'antd';

const Store = ({ storeFormButton, data, setData, onSave }) => {
  const [date, setDate] = useState({
    startDate: new Date(),
  });
  const [timer, setTimer] = useState('sendNow');
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const [storeData, setStoreData] = useState({
    APN_key: '',
    appleTeamId: '',
    isCheckedGooglePlay: false,
    isCheckedAppleDeveloper: false,
    apn: null,
    apn_url: '',
    iosBundleId: '',
    androidBundleId: '',
    willSendTime: '',

    email: '',
    tel: '',
    demoUserName: '',
    demoUserPassword: '',
    isPublishByMobligoApproved: '',
    isContentReviewApproved: '',
    isInformationConfirmed: '',
    storeUrl: '',
    supportUrl: '',
  });

  const uploadClientData = async (key, fileData) => {
    if (!fileData) return;
    const formData = new FormData();
    formData.append(key, fileData); // Append the file to FormData

    const response = await CreateAction({
      method: 'post',
      path: `/uploadPrivateFile`,
      showPreLoader: true,
      isFileUploading: false,
      data: formData,
    });
    if (response.error) return;
    updateStoreData(key, fileData);

    updateStoreData('apn_url', response?.result?.resultData);
    console.log(response?.result?.resultData);
  };

  const updateStoreData = (key, value) => {
    setStoreData(state => ({ ...state, [key]: value }));
  };

  useEffect(() => {
    updateStoreData('willSendTime', timer === 'sendNow' ? new Date() : date?.startDate);
  }, [timer, date]);
  return (
    <form
      className="flex flex-col gap-[20px] items-center w-full "
      onSubmit={e => {
        e.preventDefault();
        e.stopPropagation();
        const { apn, apn_url } = storeData;
        if ((!apn || !apn_url) && isOpen) {
          dispatch(systemSlice.actions.setToastError({ detail: translate('missingApn') }));
          return;
        }

        setData(state => ({ ...state, ...storeData }));
        setTimeout(() => {
          onSave({ ...data, ...storeData });
        });
      }}
    >
      <div className="bg-white p-4 rounded-lg shadow-xl w-[99%] mb-6">
        <div id="platform-requirements">
          <div className="section-header bg-slate-50 border-b-2 border-slate-200 p-4 mb-6">
            <h2 className="text-2xl font-bold text-gray-900">✅ Yayın Onayı</h2>
            <p className="text-gray-600 mt-2">Yayın öncesi son kontroller ve onaylar.</p>
          </div>

          <div className="mb-6">
            <div className="mb-6 text-lg">Uygulama Durumu</div>
            {/* asd */}
            <div className=" flex flex-col mb-6">
              <span className="text-[#5E5873] mb-[20px] block font-semibold text-[18px] ">Zamanlama</span>
              <RadioGroup value={timer}>
                <Radio value="sendNow" onChange={e => setTimer('sendNow')}>
                  Şimdi Gönder
                </Radio>
                <Radio value="sendLater" onChange={e => setTimer('sendLater')}>
                  İleri Tarihe Ayarla
                </Radio>
              </RadioGroup>
              {timer === 'sendLater' && (
                <div className="mt-[20px]">
                  <div className=" w-[100%] pr-[10px] flex flex-row gap-[5px]">
                    <div className="flex px-[12px] rounded-[5px] border-1 border-[#E3E8EF] items-center gap-[15px]"></div>
                  </div>
                  <div>
                    <Datepicker
                      displayFormat="YYYY-MM-DD"
                      primaryColor={'purple'}
                      value={date}
                      useRange={false}
                      asSingle={true}
                      onChange={newValue => setDate(newValue)}
                    />
                  </div>
                </div>
              )}
            </div>
            {/* asda */}
            <div className="info-box mt-8 bg-slate-50 border-l-4 border-indigo-500 p-4 text-sm text-slate-600">
              <p className="font-medium">⏱️ İnceleme Süreleri:</p>
              <ul className="list-disc ml-4 mt-1">
                <li>Apple: 24-48 saat</li>
                <li>Google Play: 2-7 gün</li>
                <li>Pazarlama kampanyalarınızı bu süreleri göz önünde bulundurarak planlayın</li>
              </ul>
            </div>
          </div>
          <div className="mb-6">
            <div className="flex mb-6 text-lg">
              İletişim Bilgileri
              <div className="relative  group cursor-pointer ml-1">
                <svg
                  fill="#3A80F6"
                  width="24px"
                  height="24px"
                  viewBox="0 0 12.8 12.8"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>ionicons-v5-e</title>
                  <path d="M6.4 1.4C3.643 1.4 1.4 3.643 1.4 6.4s2.243 5 5 5 5 -2.243 5 -5S9.157 1.4 6.4 1.4m0 2.05a0.65 0.65 0 1 1 -0.65 0.65 0.65 0.65 0 0 1 0.65 -0.65m1.2 5.65h-2.2a0.4 0.4 0 0 1 0 -0.8h0.7v-2.2h-0.4a0.4 0.4 0 0 1 0 -0.8h0.8a0.4 0.4 0 0 1 0.4 0.4v2.6h0.7a0.4 0.4 0 0 1 0 0.8" />
                </svg>
                <div className="absolute bottom-full mb-1  w-max max-w-[300px] bg-[#1D40AF] text-white text-xs rounded py-2 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                  İnceleme ekibinin soruları için
                </div>
              </div>
            </div>
            <div className="flex flex-row justify-between">
              <div className="w-[48%]">
                <MyInput
                  value={storeData.email}
                  onChange={e => updateStoreData('email', e)}
                  type={'email'}
                  // isRequired={true}
                  label={'İletişim E-posta'}
                  placeholder="E-posta adresinizi girin"
                />
              </div>
              <div className="w-[48%]">
                <label className={`block mb-2 text-sm font-medium text-gray-900`}>İletişim Telefon</label>
                <PhoneInput
                  preferredCountries={['tr', 'de']}
                  inputStyle={{
                    width: '100%',
                    borderWidth: '1px',
                    borderColor: '#D4DBE3',
                    height: '45px',
                    borderRadius: '0.5rem',
                    paddingLeft: '3.5rem',
                  }}
                  inputClass="border-red-500"
                  buttonStyle={{ width: '45px', background: 'white', borderColor: '#D4DBE3' }}
                  buttonClass=""
                  searchClass=""
                  dropdownClass=""
                  country={'tr'}
                  value={storeData.tel}
                  onChange={phone => updateStoreData('tel', phone)}
                />
              </div>
            </div>
          </div>
          <div className="mb-6">
            <div className="mb-6 text-lg">Demo Hesap Bilgileri</div>
            <div className=" flex flex-row justify-between">
              <div className="w-[48%]">
                <MyInput
                  value={storeData.demoUserName}
                  onChange={e => updateStoreData('demoUserName', e)}
                  type={'text'}
                  // isRequired={true}
                  label={'Demo Kullanıcı Adı'}
                  placeholder="Demo kullanıcı adınızı girin"
                />
              </div>
              <div className="w-[48%]">
                <p className="block mb-2 text-sm font-medium text-gray-900 text-stale-400 ">Demo Şifre</p>
                <MyInput
                  value={storeData.demoUserPassword}
                  onChange={e => updateStoreData('demoUserPassword', e)}
                  type="password"
                  // isRequired={true}
                  classes="bg-transparent h-14"
                  placeholder="Demo şifrenizi girin"
                />
              </div>
            </div>
          </div>
          <div className="info-box mt-8 bg-slate-50 border-l-4 border-indigo-500 p-4 text-sm text-slate-600 mb-6">
            <p className="font-medium">
              ℹ️ Oturum açma gerektiren özellikler varsa, inceleme ekibinin test edebilmesi için demo hesap bilgileri
              gereklidir.
            </p>
          </div>
          <div>
            <div className="mb-6">
              <div className=" flex flex-row justify-between">
                <div className="w-[48%]">
                  <MyInput
                    value={storeData.storeUrl}
                    onChange={e => updateStoreData('storeUrl', e)}
                    maxLength={60}
                    isLengthActive
                    isRequired={true}
                    label={
                      <div>
                        Web Site Linki <span className="text-red-500">*</span>
                      </div>
                    }
                    tooltip={
                      <>
                        • Kullanıcıların uygulamanız hakkında daha fazla bilgi edinebileceği ilk kaynak
                        <br />• Güvenilir ve güncel bir site, markanıza olan güveni artırır
                      </>
                    }
                    placeholder="Web Site Linki (max 60 karakter)"
                  />
                </div>

                <div className="w-[48%]">
                  <MyInput
                    value={storeData.supportUrl}
                    onChange={e => updateStoreData('supportUrl', e)}
                    maxLength={60}
                    isLengthActive
                    isRequired={true}
                    label={
                      <div>
                        Web Site Destek Linki <span className="text-red-500">*</span>
                      </div>
                    }
                    tooltip={
                      <>
                        • Destek linki, güven oluşturur ve kullanıcı memnuniyetini artırır
                        <br />• Net ve erişilebilir bir destek sayfası, olumsuz yorum riskini azaltır
                      </>
                    }
                    placeholder="Web Site Destek Linki (max 60 karakter)"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className=" flex flex-col gap-[10px] w-full">
            <div>Uygulama Yayınlama Ayarları</div>
            <Toggle
              value={isOpen}
              setItem={() => {
                setIsOpen(state => !state);
              }}
              targetKey={'uploadAppOnCustomStore'}
            />
            <div className="flex flex-row gap-[20px] flex-wrap mb-6">
              {isOpen ? (
                <>
                  <div className="w-[1090px] mx-auto">
                    <FirebaseIntegrationsItem
                      icon={
                        <img
                          src="https://mobligo-bucket.s3.eu-central-1.amazonaws.com/ios%2B-removebg-preview.png"
                          width={45}
                          height={45}
                          alt="APN logo"
                        />
                      }
                      firebaseData={storeData}
                      onFileUpload={uploadClientData}
                      onUploadName={'apn'}
                      acceptedTypes={['.p8']}
                      header={'Apple Push Notification'}
                      description={'APN .p8 dosyası'}
                    />
                  </div>
                  <div className="flex flex-col gap-[20px] justify-center mx-auto">
                    <div className="w-[1050px] flex flex-row justify-between">
                      <div className="flex flex-col w-[500px]">
                        <MyInput
                          isRequired
                          value={storeData.APN_key}
                          onChange={e => updateStoreData('APN_key', e)}
                          className=""
                          maxLength={100}
                          isLengthActive={true}
                          label={'APN Key Numarası'}
                          placeholder="APN key numarası giriniz."
                          classes={'w-[500px]'}
                        />
                      </div>
                      <div className="flex flex-col w-[500px]">
                        <MyInput
                          isRequired
                          value={storeData.appleTeamId}
                          onChange={e => updateStoreData('appleTeamId', e)}
                          className=""
                          maxLength={100}
                          isLengthActive={true}
                          label={"Apple Developer Takım Id'si"}
                          placeholder="Apple Developer Takım Id'si giriniz."
                          classes={'w-[500px]'}
                        />
                      </div>
                    </div>

                    <div className="w-[1050px] flex flex-row justify-between">
                      <div className="flex flex-col w-[500px]">
                        <MyInput
                          isRequired
                          value={storeData.iosBundleId}
                          onChange={e => updateStoreData('iosBundleId', e)}
                          className=""
                          maxLength={100}
                          isLengthActive={true}
                          label={'iOS bundle id'}
                          placeholder="iOS bundle id"
                          classes={'w-[500px]'}
                        />
                      </div>
                      <div className="flex flex-col w-[500px]">
                        <MyInput
                          isRequired
                          value={storeData.androidBundleId}
                          onChange={e => updateStoreData('androidBundleId', e)}
                          className=""
                          maxLength={100}
                          isLengthActive={true}
                          label={'Android bundle id'}
                          placeholder="Android bundle id"
                          classes={'w-[500px]'}
                        />
                      </div>
                    </div>

                    <div className="w-[1050px] flex flex-col justify-between gap-[30px] mt-[10px]">
                      <div className="gap-[10px]">
                        <label className={`block mb-2 text-sm font-medium text-gray-900`}>
                          Uygulamanız{' '}
                          <a target="_blank" href="https://play.google.com/" className="text-[#7059ef]">
                            Play Store
                          </a>{' '}
                          üzerinde yayınlanabilmesi için Play Store hesabınıza erişim yetkisi vermeniz gerekmektedir.
                          Nasıl verileceğini öğrenmek için{' '}
                          <a target="_blank" className="text-[#7059ef]">
                            tıklayınız
                          </a>
                          .
                        </label>

                        <Checkbox
                          isRequired
                          className=""
                          checked={storeData.isCheckedGooglePlay}
                          onChange={e => {
                            updateStoreData('isCheckedGooglePlay', e.target?.checked);
                          }}
                          color="primary"
                        >
                          <span>Play Store yetkisi verdim.</span>
                        </Checkbox>
                      </div>

                      <div className="gap-[10px]">
                        <label className={`block mb-2 text-sm font-medium text-gray-900`}>
                          Uygulamanız{' '}
                          <a target="_blank" href="https://developer.apple.com/" className="text-[#7059ef]">
                            App Store
                          </a>{' '}
                          üzerinde yayınlanabilmesi için Apple Developer hesabınıza erişim yetkisi vermeniz
                          gerekmektedir. Nasıl verileceğini öğrenmek için{' '}
                          <a target="_blank" className="text-[#7059ef]">
                            tıklayınız
                          </a>
                          .
                        </label>

                        <Checkbox
                          isRequired
                          className=""
                          checked={storeData.isCheckedAppleDeveloper}
                          onChange={e => {
                            updateStoreData('isCheckedAppleDeveloper', e.target?.checked);
                          }}
                          color="primary"
                        >
                          <span>Apple Developer yetkisi verdim.</span>
                        </Checkbox>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <div>
                  <div className="text-sm pt-[10px] py-2 text-[#8A92A6] text-[15px] font-medium">
                    Uygulama mobligo üzerinden yayınlanacaktır.
                  </div>
                  <div className="flex flex-col gap-[20px] mb-6">
                    <div className="text-lg">Uygulama Durumu</div>
                    <Checkbox
                      isRequired
                      isSelected={storeData.isPublishByMobligoApproved}
                      value={storeData.isPublishByMobligoApproved}
                      onChange={() =>
                        updateStoreData('isPublishByMobligoApproved', !storeData.isPublishByMobligoApproved)
                      }
                      color="secondary"
                    >
                      Mobligo'nun uygulamamı kendi hesabından yayınlamasını onaylıyorum
                    </Checkbox>
                    <Checkbox
                      isRequired
                      isSelected={storeData.isContentReviewApproved}
                      value={storeData.isContentReviewApproved}
                      onChange={() => updateStoreData('isContentReviewApproved', !storeData.isContentReviewApproved)}
                      color="secondary"
                    >
                      Mobligo'nun uygulama içeriğimi incelemesini kabul ediyorum
                    </Checkbox>
                    <Checkbox
                      isRequired
                      isSelected={storeData.isInformationConfirmed}
                      value={storeData.isInformationConfirmed}
                      onChange={() => updateStoreData('isInformationConfirmed', !storeData.isInformationConfirmed)}
                      color="secondary"
                    >
                      Tüm bilgilerin doğru olduğunu onaylıyorum
                    </Checkbox>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <button
        className="mb-6 py-2 px-4 flex items-center justify-center bg-[#7059EF] hover:bg-[#5841D9] rounded text-[#FFFFFF] disabled:bg-[#c5bfff]  cursor-pointer disabled:cursor-not-allowed"
        type="submit"
        ref={storeFormButton}
      >
        Yayınla
      </button>
    </form>
  );
};

export default Store;
